// Servicios
const EXPORTACION = "EXPO";
const IMPORTACION = "IMPO";
const REENTREGAS = "REE";
const DEVOLUCIONES = "DEV";
const POSICIONAMIENTOS = "POS";
const ARRUMAJE = "ARMJ";
const PORTEO = "PORT";
const INLAND = "INL";

// Estados RQ
const DRAFT = "DRAFT";
const PENDIENTE = "PDTE";
const APROBADO = "APR";
const ASIGNADO = "ASI";
const ANULADO_TRAMARSA = "ANUT";
const CANCELADO_CLIENTE = "CANC";
const LLEGADA_TCT = "LLTCT";
const INGRESO_TCT = "INTCT";
const SALIDA_TCT = "STCT";
const PERNOCTAR = "PER";
const LLEGADA_CLIENTE = "LLC";
const INGRESO_CLIENTE = "INC";
const SALIDA_CLIENTE = "SC";
const LLEGADA_DV = "LLDV";
const INGRESO_DV = "INDV";
const SALIDA_DV = "SDV";
const FINALIZADO = "END";
const PENDIENTE_DEVOLUCION = "PDEV";

const INICIO_FULL = "INRECFULL";
const INICIO_MTY = "INRECMTY";

const LLEGADA_MTY = "LLAMTY";

const TERMINO_CARGA = "TCAR";
const TERMINO_DESCARGA = "TDES";

// Roles
const ADMIN = "ADM";
const PLANIFICADOR = "PLA";
const PLANIFICADOR_PORTEO = "PLP";
const SOLICITANTE = "APL";
const EJECUTIVO_COMERCIAL = "ECO";
const CONDUCTOR = "DRI";
const SUPERVISOR_VACIOS = "SV";
const SUPERVISOR_MOVIMIENTOS_INTERNOS = "SMI";
const MECANICO = "MEC";
const PLANIFICADOR_MANTENIMIENTO = "PLM";
const OPERADOR_GRUA = "OGR";
const ADMINISTRATIVO = "ATR";
const ABASTECEDOR = "ABA";
const PROVEEDOR = "PRO";
const CCTV = "CCTV";
const EJECUTIVO_CUENTA = "ECU";
const PLANIFICADOR_VACIOS = "PLAV";

// ESTADOS CONDUCTOS
const RECHAZA_CONDUCTOR = "REC";
const ACEPTA_CONDUCTOR = "ACP";

// TIPOS DE CARGA
const SUELTA = "SUELTA";
const VACIO = "VACIO";
const GENERAL = "GENERAL";
const REFRIGERADOS = "REFRIGERADOS";

const GRUA = "GR";

// ESTADOS MANTENCION
const MANT_APROBADO = "MAPR";
const MANT_FINALIZADO = "MFIN";

// TIPO MANTENCION
const PREVENTIVA = "PRE";
const CORRECTIVA = "COR";

// MODALIDAD
const OWNER = "OWNER";
const RENTED = "RENTED";
const THIRD = "THIRD";

export default {
  ABASTECEDOR,
  ADMINISTRATIVO,
  TERMINO_CARGA,
  TERMINO_DESCARGA,
  LLEGADA_MTY,
  INICIO_FULL,
  INICIO_MTY,
  MANT_FINALIZADO,
  PREVENTIVA,
  CORRECTIVA,
  MANT_APROBADO,
  GRUA,
  OPERADOR_GRUA,
  CONDUCTOR,
  EXPORTACION,
  IMPORTACION,
  REENTREGAS,
  DEVOLUCIONES,
  POSICIONAMIENTOS,
  ARRUMAJE,
  PORTEO,
  INLAND,
  DRAFT,
  PENDIENTE,
  APROBADO,
  ASIGNADO,
  ANULADO_TRAMARSA,
  CANCELADO_CLIENTE,
  LLEGADA_TCT,
  INGRESO_TCT,
  SALIDA_TCT,
  PERNOCTAR,
  LLEGADA_CLIENTE,
  INGRESO_CLIENTE,
  SALIDA_CLIENTE,
  LLEGADA_DV,
  INGRESO_DV,
  SALIDA_DV,
  FINALIZADO,
  PENDIENTE_DEVOLUCION,
  ADMIN,
  PLANIFICADOR,
  PLANIFICADOR_MANTENIMIENTO,
  MECANICO,
  PLANIFICADOR_PORTEO,
  SOLICITANTE,
  EJECUTIVO_COMERCIAL,
  SUPERVISOR_VACIOS,
  SUPERVISOR_MOVIMIENTOS_INTERNOS,
  PLANIFICADOR_VACIOS,
  RECHAZA_CONDUCTOR,
  ACEPTA_CONDUCTOR,
  SUELTA,
  VACIO,
  GENERAL,
  REFRIGERADOS,
  PROVEEDOR,
  CCTV,
  EJECUTIVO_CUENTA,
  OWNER,
  RENTED,
  THIRD
};
